const shipment = {
  shipmentMana: '发货需求',
  shipmentListPage: '发货单',
  add: '添加',
  edit: '编辑',
  delete: '删除',
  detail: '详情',
  export: '导出',
  import: '导入',
  search: '查询',
  reset: '重置',
  confirm: '确认',
  cancel: '取消',
  cancelOk: '取消成功',
  cancelFAil: '取消失败',
  confirmCancel: '是否取消发货单{{no}}吗？',
  orderNumber: '订单编号',
  customerName: '客户名称',
  status: '状态',
  sourceType: '来源类型',
  consignee: '收货人',
  consigneeAddress: '收货地址',
  consigneePhone: '收货电话',
  destinationCountry: '目的国家',
  tradeTerms: '贸易条款',
  paymentTerms: '付款方式',
  planShipDate: '计划发货日期',
  actualShipDate: '实际发货日期',
  deliveredAt: '送达时间',
  remark: '备注',
  items: '明细',
  createTime: '创建时间',
  operation: '操作',
  productCode: '商品编码',
  productName: '商品名称',
  count: '数量',
  saleOrderCount: '销售单数量',
  amount: '金额',
  uom: '单位',
  unitPrice: '单价',
  currency: '币种',
  itemRemark: '备注',
  plKeyword: '请输入订单编号或客户名称',
  shipMethod: '发货方式',
  shipLogistics: '承运人',
  shipEvent: '物流轨迹',
  saleOrder: '销售订单',
  saleOrderItem: '销售订单条目',
  selectOrder: '选择订单',
  selectOrderItem: '选择订单条目',
  noProduct: '没有商品',
  customerShipAddress: '选择收货地址',
  plCustomerName: '请输入客户名称',
  plConsignee: '请输入收货人',
  plConsigneePhone: '请输入收货电话',
  plConsigneeAddress: '请输入收货地址',
  plRemark: '请输入备注',
  plTradeTerms: '请输入贸易条款',
  plPaymentTerms: '请输入付款方式',
  plCurrency: '请输入币种',
  plCarrier: '请输入承运人',
  addPackOrder: '添加分拣单',
  yes: '是',
  no: '否',
  number: '发货单号',
  trackingNo: '物流单号',
  blNo: '提单号',
  vesselVoyage: '运次',
  containerNo: '集装箱编号',
  shipped: '已发货',
  pending: '待发货',
  shippedAt: '发货时间',
  freightCost: '运费',
  addLogistics: '添加物流',
  editLogistics: '编辑物流',
  plTrackingNo: '请输入物流单号',
  plBlNo: '请输入提单号',
  plVesselVoyage: '请输入船次/航次/班次',
  plContainerNo: '请输入集装箱编号',
  plFreightCost: '请输入运费',
  addError: '添加失败',
  saveFail: '保存失败',
  saveOk: '保存成功',
  addSuccess: '添加成功',
  freightCurrency: '运费币种',
  noPackOrder: '没有分拣单',
  shipmentNoPack: '发货单没有分拣单，不能添加物流单',
  packNoShipment: '分拣单没有发货单，不能添加物流单',
  getPackErr: "获取分拣单失败！",
  logistics: "物流单",
  eventTime: '事件时间',
  location: '位置',
  description: '描述',
  shipEvents: '物流轨迹',
  plLocation: '请输入位置',
  plDescription: '请输入描述',
  addEvent: '添加轨迹',
  doShip: '发货',
  shipOk: '发货成功',
  shipFail: '发货失败',
  viewLogistics: '查看物流',
  creator: '创建人',
  viewPackOrder: '查看分拣单',
  viewShipmentOrder: '查看发货单',
  repeated: '重复商品已忽略',
  addShipOutPl: '请先生成发货出库单！',
  hasLogis: '该发货单已有物流',
  updatePrice: "更新价格",
  priceUpSucc: "更新价格成功",
  priceUpFail: "更新价格失败",
  plSelShip: "请选择发货单",
  plSelShipErr: "只能选择同一个分拣单生成的发货单",
  exportErr: "导出失败",
};

export default shipment;
